export enum StatusCode {
  Success = 200,
  BadRequest = 400,
  NotFound = 404,
  InternalError = 500,
}

export interface ApiStatus {
  code: StatusCode;
  description: string;
}

export interface PacsParams {
  SelectServer: string;
  PatientName: string;
  PatientID: string;
  BirthDate: string;
  AccessionNumber: string;
  Description: string;
  ReferringPhysician: string;
  StudyID: string;
  StudyUID: string;
  StudyDate: string;
  SeriesUID: string;
  Modality: string;
}

export type OptionalPacsParams = Partial<PacsParams>

export const initPacsParams: PacsParams = {
  SelectServer: "",
  PatientName: "",
  PatientID: "",
  BirthDate: "",
  AccessionNumber: "",
  Description: "",
  ReferringPhysician: "",
  StudyID: "",
  StudyUID: "",
  StudyDate: "",
  SeriesUID: "",
  Modality: ""
}

export interface PACSQueryForm {
  id: string;
  form: PacsParams;
}

export interface DicomNodeParams {
  id: string;
  ip: string;
  port: number;
  aetitle: string;
  description: string;
  defaultServer : boolean;
  defaultQuery: boolean;
  defaultReportUpload: boolean;
  supportJpeg: boolean;
}

export type DicomNodeBase = Omit<
  DicomNodeParams,
  'defaultQuery' | 'defaultReportUpload' | 'supportJpeg'
>;
export type DicomNodeParamsWithoutId = Omit<DicomNodeParams, 'id'>;

export const initDicomNodeParams: DicomNodeParams = {
  id: '',
  ip: '',
  port: 0,
  aetitle: '',
  description: '',
  defaultServer: false,
  defaultQuery: false,
  defaultReportUpload: false,
  supportJpeg: false,
};

export type DicomNodeMap = Record<string, DicomNodeParams>;

